import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function Preview({ canDrop, isList }: Props) {
  return canDrop ? (
    <div className={classNames(styles.preview, { [styles.list]: isList })}>
      <ToggleArrow className={styles.icon} />
    </div>
  ) : (
    <React.Fragment />
  );
}

export { Preview };
